// @ts-nocheck
// This file is generated automatically by `useTemplate.ts`. DO NOT EDIT IT.

import { tag } from 'omi';
import { IconBase, IconProps } from '../icon';

const element = {"attributes":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"nodeName":"svg","children":[{"attributes":{"id":"mosque"},"nodeName":"g","children":[{"attributes":{"id":"fill1","fill":"transparent","d":"M12 4C14.7614 4 17 6.23858 17 9H20V21H4V9H7C7 6.23858 9.23858 4 12 4Z"},"nodeName":"path","children":[]},{"attributes":{"id":"fill2","fill":"transparent","d":"M9 21V15H15V21H9Z"},"nodeName":"path","children":[]},{"attributes":{"id":"stroke2","stroke":"currentColor","d":"M9 21V15H15V21H9Z","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]},{"attributes":{"id":"stroke1","stroke":"currentColor","d":"M4 9V21H20V9M4 9H3M4 9H7M20 9H21M20 9H17M7 9H17M7 9C7 6.23858 9.23858 4 12 4M17 9C17 6.23858 14.7614 4 12 4M12 4L12.002 3","stroke-linecap":"square","stroke-width":2},"nodeName":"path","children":[]}]}]};

@tag('t-icon-mosque')
export default class MosqueIcon extends IconBase<IconProps> {
  static icon = element;
  constructor() {
    super();
    this.props = {
      ...this.props,
      id: 'mosque',
    }
  }
}
